import { useTranslation } from "@/hooks/useTranslation";
import { TeamKnowledgeWebsiteDTO } from "@shaarp/common";
import { DataTable } from "../data-table/data-table";
import { dataTableTeamKnowledgeWebsitesColumns } from "./data-table-team-knowledge-websites-columns";

export default function DataTableTeamKnowledgeWebsites({
  websites,
  isLoading,
  onDelete,
  onRefresh,
}: {
  websites: TeamKnowledgeWebsiteDTO[];
  isLoading: boolean;
  onDelete: (website: TeamKnowledgeWebsiteDTO) => void;
  onRefresh: (website: TeamKnowledgeWebsiteDTO) => void;
}) {
  const { t } = useTranslation();

  return (
    <DataTable
      data={websites}
      columns={dataTableTeamKnowledgeWebsitesColumns(t, onDelete, onRefresh)}
      columnsPersistenceKey="data-table-team-knowledge-websites"
      emptyText={t("team.knowledge.dataTable.emptyTextWebsites")}
      isLoading={isLoading}
      showFilter={false}
    />
  );
}
